import { useNavigate } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { useState, useEffect, useRef } from "react";
import { FlagIcon } from "react-flag-kit";
import { loadSectionTexts } from "../../utils/contentService";

export default function Navbar() {
  const navigate = useNavigate();
  const { i18n } = useTranslation();
  const [texts, setTexts] = useState({});
  const [isDropdownOpen, setIsDropdownOpen] = useState(false);
  const dropdownRef = useRef(null);

  const languages = {
    en: { name: "English", flag: "GB" },
    bg: { name: "Български", flag: "BG" },
    de: { name: "Deutsch", flag: "DE" },
  };

  useEffect(() => {
    setTexts(loadSectionTexts("nav", i18n.language));
  }, [i18n.language]);

  const changeLanguage = (lng) => {
    i18n.changeLanguage(lng);
    setIsDropdownOpen(false);
  };

  // Close dropdown when clicking outside
  useEffect(() => {
    const handleClickOutside = (event) => {
      if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
        setIsDropdownOpen(false);
      }
    };

    document.addEventListener("mousedown", handleClickOutside);
    return () => document.removeEventListener("mousedown", handleClickOutside);
  }, []);

  const currentLang = i18n.language || "bg";

  return (
    <nav className="w-full h-16 md:h-20 bg-test shadow-md fixed top-0 left-0 z-50 flex items-center justify-between md:justify-end px-3 md:px-4 lg:pr-[10px] gap-2 md:gap-3">
      {/* Language Dropdown */}
      <div className="relative" ref={dropdownRef}>
        <button
          onClick={() => setIsDropdownOpen(!isDropdownOpen)}
          className="w-12 h-12 md:w-14 md:h-14 lg:w-16 lg:h-16 bg-white rounded-xl flex items-center justify-center hover:bg-gray-100 transition-all duration-300 shadow-lg"
          aria-label="Select language"
        >
          <div className="w-7 h-7 md:w-9 md:h-9 flex items-center justify-center">
            <FlagIcon code={languages[currentLang]?.flag || "BG"} size={36} />
          </div>
        </button>

        {isDropdownOpen && (
          <div className="absolute top-full mt-2 left-0 md:right-0 md:left-auto bg-white rounded-xl shadow-xl overflow-hidden min-w-[140px] md:min-w-[150px] z-[60]">
            {Object.keys(languages).map((lang) => (
              <button
                key={lang}
                onClick={() => changeLanguage(lang)}
                className={`w-full px-3 md:px-4 py-2 md:py-3 flex items-center gap-2 md:gap-3 hover:bg-gray-100 transition-colors ${currentLang === lang ? "bg-gray-50" : ""
                  }`}
              >
                <div className="w-5 h-5 md:w-6 md:h-6 flex items-center justify-center">
                  <FlagIcon code={languages[lang].flag} size={24} />
                </div>
                <span className="text-xs md:text-sm font-medium font-serif">
                  {languages[lang].name}
                </span>
              </button>
            ))}
          </div>
        )}
      </div>

      {/* Confirmation Button */}
      <button
        onClick={() => navigate("/confirmation")}
        className="w-auto px-6 md:px-8 lg:w-56 h-12 md:h-14 lg:h-16 bg-blue1 rounded-xl flex items-center justify-center hover:bg-blue transition-all duration-300 shadow-lg"
      >
        <span className="text-base md:text-xl lg:text-[23px] font-normal font-serif italic text-white leading-none text-center whitespace-nowrap">
          {texts.confirmation || ""}
        </span>
      </button>
    </nav>
  );
}
